import React, { useState, useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Table, Input, Pagination } from 'antd'
import { Alert } from '../../../Communal/utility';
import instance from '../../../Communal/instance';
import DeteleBox from '../../deteleBox';
import RulesClassifyForm from './rulesClassifyForm';
import { stringify } from 'querystring';

const RuleClassify = ({ keyword, userType, userIssue }) => {
    const [initData, setInitData] = useState({
        data: [],
        allCount: 0
    });
    const [checkList, setCheckList] = useState([]);
    const [filter, setFilter] = useState({
        page: 1,
        size: 10,
        search: keyword,
        classify: [],
        stage: [],
        status: [],
        username: "",
    });
    const [deleteTip, setDeleteTip] = useState({
        show: false,
        list: []
    })
    const [filteredList, setFilteredList] = useState({
        classify: [],
        stage: [],
        status: []
    });
    const [submit, setSubmit] = useState({
        show: false,
        id: undefined,
        type: "0"
    })

    useEffect(() => {
        tableData()
    }, [filter])

    useEffect(() => {
        return () => {
            setFilter({
                page: 1,
                size: 10,
                search: keyword,
                classify: [],
                stage: [],
                status: [],
                username: "",
            })
        }
    }, [])

    const tableData = () => {
        instance.get('/rules/class/', { params: filter }).then(data => {
            initData.data = data.results;
            initData.allCount = data.count;
            setInitData({ ...initData })
        })
    }

    const handleTableChange = (pagination, filters) => {
        if (filters.status) {
            filter.status = filters.status;
            filteredList.status = filters.status;
        } else {
            filter.status = [];
            filteredList.status = [];
        }
        filter.page = 1;
        setFilter({ ...filter });
        setFilteredList({ ...filteredList })
    }
    //单个删除或者批量删除操作
    const resourceDelete = (list) => {
        if (list.length === 0) {
            Alert("warn", "请选择需要删除的规则类型");
            return
        }
        instance.post("/rules/class/batch/", { ids: list, status: 1 }).then(data => {
            if (filter.page > 1 && (initData.data.length === list.length)) {
                filter.page -= 1;
                setFilter({ ...filter })
            }
            if (initData.allCount === list.length) {
                filter.page = 1;
                setFilter({ ...filter })
            }
            tableData();
            Alert("success", "删除成功");
            setCheckList([]);
            deleteTip.list = [];
            deleteTip.show = false;
            setDeleteTip({ ...deleteTip })
        })
    }

    const rowSelection = {
        selectedRowKeys: checkList,
        preserveSelectedRowKeys:true,
        onChange: (selectedRowKeys, selectedRows) => {
            deleteTip.list = selectedRowKeys
            setDeleteTip({ ...deleteTip })
            setCheckList(selectedRowKeys)
        },
    }
    const columns = [
        {
            title: '序号',
            key: 'id',
            width: 70,
            align: 'center',
            fixed: 'left',
            render: (text, record, index) => (
                <span
                    className="click-href"
                    onClick={() => {
                        let list = { ...submit }
                        list.show = true
                        list.type = "3"
                        list.id = record.id
                        setSubmit({ ...list })
                    }}
                >
                    {filter.size * (filter.page - 1) + index + 1}
                </span>
            )
        }, {
            title: '中文分类名称',
            align: 'center',
            key: 'name',
            dataIndex: 'name',
            fixed: 'left',
            width: 150,
            ellipsis: true,
        }, {
            title: '英文标识',
            key: 'english_name',
            dataIndex: 'english_name',
            align: 'center',
            fixed: 'left',
            width: 150,
            ellipsis: true,
        }, {
            title: '规则统计',
            key: 'rules_num',
            dataIndex: 'rules_num',
            width: 100,
            align: 'center',
        }, {
            title: '审核状态',
            key: 'status',
            dataIndex: 'status',
            width: 100,
            align: 'center',
            filters: [
                { text: "待审核", value: "0" },
                { text: "通过", value: "1" },
                { text: "待补充", value: "2" },
                { text: "拒绝", value: "3" }
            ],
            render: (record) => {
                return <span className="audit-status">
                    {
                        record === 0 && "待审核"
                    }
                    {
                        record === 1 && <span className="pass">通过</span>
                    }
                    {
                        record === 2 && <span className="added">待补充</span>
                    }
                    {
                        record === 3 && <span className="denied">拒绝</span>
                    }
                </span>
            },
        },
        {
            title: '提交者',
            key: 'username',
            dataIndex: 'username',
            width: 150,
            align: 'center',
            ellipsis: true,
            filterDropdown: ({ clearFilters }) => (
                <div className="table-search">
                    <Input
                        placeholder="请输入提交者名称"
                        value={filter.username}
                        onChange={(e) => {
                            filter.username = e.target.value;
                            filter.page = 1;
                            setFilter({ ...filter })
                        }}
                    />
                    <Button
                        type="primary"
                        onClick={() => { clearFilters() }}
                    >
                        确定
                    </Button>
                    <Button onClick={() => {
                        clearFilters();
                        filter.username = "";
                        filter.page = 1;
                        setFilter({ ...filter })
                    }}>取消</Button>
                </div>
            ),
            filterIcon: <SearchOutlined />
        }, {
            title: '提交时间',
            key: 'sub_time',
            dataIndex: 'sub_time',
            width: 200,
            align: 'center',
        }, {
            title: '操作',
            key: 'operate',
            dataIndex: 'operate',
            align: 'center',
            fixed: 'right',
            width: userType > 1 ? 250 : 200,
            render: (text, record) => {
                return <div className="table-operation">
                    <Button
                        type="link"
                        onClick={() => {
                            let list = { ...submit }
                            list.show = true
                            list.type = "3"
                            list.id = record.id
                            setSubmit({ ...list })
                        }}
                    >
                        详情
                    </Button>
                    <Button
                        key="2"
                        type="link"
                        disabled={userType < 2 && record.status === 1}
                        onClick={() => {
                            let list = { ...submit }
                            list.show = true
                            list.type = "1"
                            list.id = record.id
                            setSubmit({ ...list })
                        }}
                    >
                        编辑
                    </Button>
                    {
                        userType > 1 ? <>
                            <Button
                                key="4"
                                type="link"
                                onClick={() => {
                                    let list = { ...submit }
                                    list.show = true
                                    list.type = "2"
                                    list.id = record.id
                                    setSubmit({ ...list })
                                }}
                            >
                                审核
                            </Button>
                        </> : undefined
                    }
                    <Button
                        key="6"
                        type="link"
                        danger
                        disabled={userType < 2 && record.status === 1}
                        onClick={() => {
                            deleteTip.show = true
                            deleteTip.list = [record.id]
                            setDeleteTip({ ...deleteTip })
                        }}
                    >删除</Button>
                </div>
            }
        }
    ]

    return (
        <div className="ctf-resource-list" style={{ padding: 0 }}>
            <div className="ctf-resource-table content-container" style={{ marginTop: 0 }}>
                <div className="handle">
                    {
                        userType > 1 ?
                            <>
                                <div style={{ display: 'inline-block' }}>
                                    <Button
                                        type='ghost'
                                        disabled={checkList.length === 0}
                                        danger
                                        onClick={() => {
                                            deleteTip.show = true;
                                            deleteTip.list = checkList;
                                            setDeleteTip({ ...deleteTip })
                                        }}
                                    >
                                        批量删除
                                    </Button>
                                    <a href={"/rules/class/batch/?" + stringify({ ids: checkList })}>
                                        <Button
                                            type='primary'
                                            style={{ marginLeft: '15px' }}
                                            disabled={checkList.length <= 0}
                                            onClick={() => {
                                                setTimeout(() => {
                                                    setCheckList([])
                                                }, 1000)
                                            }}
                                        >
                                            批量导出
                                        </Button>
                                    </a>
                                </div>

                            </>
                            : undefined
                    }
                    <div className='right'>
                        {userType > 1 ?
                            <a href={"/rules/class/batch/"} >
                                <Button
                                    type='primary'
                                    disabled={initData.allCount === 0}
                                    style={{ marginRight: '15px' }}
                                >
                                    全部导出
                                </Button>
                            </a>
                            : undefined
                        }
                        <Button
                            type="primary"
                            onClick={() => {
                                let list = { ...submit }
                                list.show = true
                                list.type = "0"
                                setSubmit({ ...list })
                            }}
                        >
                            提交分类
                        </Button>
                    </div>
                </div>
                <Table
                    dataSource={initData.data}
                    rowKey={record => record.id}
                    bordered
                    rowSelection={rowSelection}
                    onChange={handleTableChange}
                    columns={columns}
                    pagination={false}
                    scroll={{ x: 1600 }}
                />
                <Pagination
                    showQuickJumper={true}
                    current={filter.page}
                    pageSize={filter.size}
                    total={initData.allCount}
                    hideOnSinglePage={initData.allCount === 0}
                    pageSizeOptions={['10', '20', '50', '100']}
                    showSizeChanger={true}
                    className="flip-over"
                    style={{ margin: "30px 0" }}
                    onChange={
                        ((page,pageSize) => {
                            let data = { ...filter }
                            data.page = page;
                            data.size = pageSize;
                            setFilter(data)
                        })
                    }
                />
            </div>
            {
                deleteTip.show &&
                <DeteleBox
                    close={() => {
                        deleteTip.show = false;
                        deleteTip.list = [];
                        setDeleteTip({ ...deleteTip })
                    }}
                    title='规则分类'
                    submit={() => resourceDelete(deleteTip.list)}
                />
            }
            <RulesClassifyForm
                submitTip={submit}
                close={() => {
                    submit.show = false;
                    submit.type = "0";
                    setSubmit({ ...submit })
                }}
                userType={userType}
                getData={tableData}
            />
        </div >
    )
}

export default RuleClassify;